import { useTranslation } from '@rbx/intl';
import { Typography } from '@rbx/ui';
import React, { FC } from 'react';
import { MemberType, ReferenceType } from '@modules/client';
import DynamicallyRouted from '@modules/miscellaneous/common/components/DynamicallyRouted';
import { getReferencePageUrl } from '../../utils/apiReferencePageNavUtils';
import { urlHashByMemberTypeDetailSection } from '../../constants/apiReferenceConstants';

interface ViewInheritedFromLinkProps {
  memberType: MemberType;
  className?: string;
  engineReferenceClassName: string;
}

export const InstanceReferenceMemberName = 'Instance';
export const ObjectReferenceMemberName = 'Object';

const ViewInheritedFromLink: FC<React.PropsWithChildren<ViewInheritedFromLinkProps>> = ({
  memberType,
  className,
  engineReferenceClassName,
}) => {
  const { translate } = useTranslation();
  return (
    <div className={className} aria-label={engineReferenceClassName} role='row'>
      <Typography marginTop={1} marginBottom={1} variant='largeLabel1' component='div'>
        <DynamicallyRouted.Link
          href={getReferencePageUrl(
            ReferenceType.CLASS,
            engineReferenceClassName,
            urlHashByMemberTypeDetailSection[memberType],
          )}
          rel='noreferrer'>
          {translate('Message.ViewAllInheritedFromParent', {
            parent: engineReferenceClassName,
          }) || `View all inherited from ${engineReferenceClassName}`}
        </DynamicallyRouted.Link>
      </Typography>
    </div>
  );
};

export default ViewInheritedFromLink;
